import * as d3 from "d3";

// Geometry helpers over the Voronoi mesh. These lived twice — once in lib/map.js and once in
// lib/util/path.js, `neighbours` byte-identical between them — which meant the router and the
// generator could drift apart on what counts as adjacent. One copy, both import it.

// The indices of every vertex adjacent to `i`. Returns a fresh array, so a caller may push onto it
// without corrupting the mesh's adjacency structure — getSlopes relies on that.
export function neighbours(mesh, i) {
  return (mesh.adj[i] || []).slice();
}

// Euclidean distance between two vertices, by index.
export function distance(mesh, i, j) {
  const p = mesh.vxs[i];
  const q = mesh.vxs[j];
  if (!p || !q) {
    throw new Error(`Vertex index out of bounds: ${i}, ${j}`);
  }
  // Explicit sqrt rather than Math.hypot: this sits in the router's inner loop, and hypot's
  // overflow guard costs more than it is worth on coordinates bounded by the unit extent.
  const dx = p[0] - q[0];
  const dy = p[1] - q[1];
  return Math.sqrt(dx * dx + dy * dy);
}

// A vertex on the hull — fewer than three neighbours means the triangulation stopped here.
export function isedge(mesh, i) {
  return mesh.adj[i].length < 3;
}

// A vertex in the outer margin of the extent. Cities and slope strokes stay out of it so the
// world does not run off the edge of the paper.
const EDGE_MARGIN = 0.45;

export function isnearedge(mesh, index) {
  const [x, y] = mesh.vxs[index];
  const w = EDGE_MARGIN * mesh.extent.width;
  const h = EDGE_MARGIN * mesh.extent.height;
  return x < -w || x > w || y < -h || y > h;
}

// The q-th quantile of a height field (or any array-like of numbers).
export function quantile(h, q) {
  const sorted = Array.prototype.slice.call(h).sort(d3.ascending);
  return d3.quantile(sorted, q);
}
